export const salesLabX = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 20,
  inputPaddingInline: 20,

  inputHeight: 45,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 16,
  inputFontFamily: '"Roboto", sans-serif',
  inputColor: "#959da5",
  inputBackgroundColor: "#fff",
  inputFontWeight: 300,

  inputBorderColor: "#f1f3f5",
  inputBorderWidth: 1,
  inputBorderRadius: 7,

  inputHoverColor: "#959da5",
  inputHoverBorderColor: "#f1f3f5",
  inputHoverBackgroundColor: "#fff",

  // **********************************
  //  Select field
  selectTopSpacing: 20,
  selectPaddingInline: 20,

  selectHeight: 45,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 16,
  selectFontFamily: '"Roboto", sans-serif',
  selectColor: "#959da5",
  selectBackgroundColor: "#fff",
  selectFontWeight: 300,

  selectBorderColor: "#f1f3f5",
  selectBorderWidth: 1,
  selectBorderRadius: 10,

  selectHoverColor: "#959da5",
  selectHoverBorderColor: "#f1f3f5",
  selectHoverBackgroundColor: "#fff",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 20,
  textAreaPaddingInline: 20,

  textAreaHeight: 45,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 16,
  textAreaFontFamily: '"Roboto", sans-serif',
  textAreaColor: "#959da5",
  textAreaBackgroundColor: "#fff",
  textAreaFontWeight: 300,

  textAreaBorderColor: "#f1f3f5",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 10,

  textAreaHoverColor: "#959da5",
  textAreaHoverBorderColor: "#f1f3f5",
  textAreaHoverBackgroundColor: "#fff",

  // **********************************
  //  placeholder
  placeholderColor: "#959da5",
  placeholderFontFamily: '"Roboto", sans-serif',
  placeholderFontSize: 16,
  placeholderFontWeight: 300,
  placeholderHoverColor: "#fafafa",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 5,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 16,
  fieldLabelColor: "#959da5",
  fieldLabelFontWeight: 300,
  fieldLabelColorAsterisk: "#959da5",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Roboto", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#959da5",
  descriptionFontSize: 16,
  descriptionFontWeight: 300,
  descriptionFontFamily: '"Roboto", sans-serif',
  descriptionTopSpacing: 5,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 15,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 0,
  checkboxUncheckedBorderColor: "#f1f3f5",
  checkboxUncheckedBackgroundColor: "#fff",
  checkboxCheckedBackgroundColor: "#1eb0ec",
  checkboxCheckedBorderColor: "#1eb0ec",
  checkboxCheckedColor: "#fff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Roboto", sans-serif',
  checkboxLabelFontSize: 16,
  checkboxLabelFontWeight: 300,
  checkboxLabelColor: "#959da5",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 15,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#f1f3f5",
  radioUncheckedBackgroundColor: "#fff",
  radioCheckedBackgroundColor: "#1eb0ec",
  radioCheckedBorderColor: "#f1f3f5",

  radioAlignment: "none",

  radioLabelFontFamily: '"Roboto", sans-serif',
  radioLabelFontSize: 16,
  radioLabelFontWeight: 300,
  radioLabelColor: "#959da5",

  // **********************************
   // toggles

   toggleLabelFontFamily: '"Roboto", sans-serif',
   toggleLabelFontSize: 16,
   toggleLabelFontWeight: 300,
   toggleLabelColor: "#959da5",
 
   // **********************************
  // submit button

  submitMarginTop: 30,
  submitFontSize: 20,
  submitFontFamily: "'Roboto', sans-serif",
  submitWidth: 200,
  submitWidthUnits: "px",
  submitHeight: 50,
  submitBorderRadius: 20,
  submitBorderWidth: 1,
  submitBackground: "#1eb0ec",
  submitColor: "#fff",
  submitBorderColor: "#1eb0ec",
  submitBackgroundHover: "#434243",
  submitBorderColorHover: "#434243",
  submitColorHover: "#fff",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 300,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "center",
};

  